export default __webpack_public_path__ + "static/media/msf_xl2.eebe3440.png";